"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("CartItemUseOnDay");
var React = require("react");

var CheckoutActions = require("./CheckoutActions");
var CheckoutStore = require("./CheckoutStore");

class CartItemUseOnDay extends React.Component {
	constructor(props) {
		super(props);

		var state = this.getStateFromStore(props);
		var wizardUseOnDays = CheckoutStore.get("wizardUseOnDays") || { allowedUseOnDays: [] };
		var allowedUseOnDays = wizardUseOnDays.allowedUseOnDays || [];
		var useOnDays = props.useOnDays;
		var useOnDay;

		if (allowedUseOnDays && useOnDays) {
			for (var i = useOnDays.length - 1; i >= 0; --i) {
				useOnDay = useOnDays[i];
				var allowedIndex = allowedUseOnDays.indexOf(useOnDay.value);
				if (allowedIndex === -1) {
					// UseOnDay is not allowed
					useOnDays.splice(i, 1);
				} else if (useOnDay.useDefaultDescription) {
					// UseOnDay should use default description
					useOnDay.description = wizardUseOnDays[`${useOnDay.value}_Description`];
				}
			}
		} else {
			useOnDays = [];
		}

		state.useOnDays = useOnDays;

		this.state = state;

		this._onChange = this._onChange.bind(this);
	}

	handleChange(event) {
		CheckoutActions.setDonationUseOnDay(this.props.cartItemId, event.currentTarget.value);
		CheckoutActions.updateDonation(this.props.cartItemId);
	}

	getStateFromStore(props) {
		return {
			selectedUseOnDay: CheckoutStore.getDonationUseOnDay((props || this.props).cartItemId)
		};
	}

	_onChange() {
		this.setState(this.getStateFromStore());
	}

	componentDidMount() {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		CheckoutStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
		CheckoutStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
			CheckoutActions.setDonationUseOnDay(this.props.cartItemId, null);
		}
	}

	render() {
		var selectedUseOnDay = this.state.selectedUseOnDay;
		var enabled = this.props.isDesignMode || CheckoutStore.getDonationFrequency(this.props.cartItemId) !== "O";
		var useOnDays = this.state.useOnDays;
		var showEmpty = !selectedUseOnDay || useOnDays.findIndex(useOnDay => (useOnDay.value || "").toString() === (selectedUseOnDay || "").toString()) === -1;

		return (
			<span
				data-react-component-name="CartItemUseOnDay"
				data-react-component-category="DonationCartItemComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<select
					value={selectedUseOnDay || ""}
					onChange={this.handleChange.bind(this)}
					className={classNames(this.props.className, {disabled: !enabled})}
					style={this.props.isDesignMode ? {"pointerEvents": "none"} : undefined}
					data-override-classes={this.props.className}
					disabled={!enabled}
				>
					{showEmpty &&
						<option value="" />
					}
					{useOnDays && useOnDays.map(useOnDay => {
						return (
							<option key={useOnDay.value} value={useOnDay.value}>
								{useOnDay.description}
							</option>
						);
					})}
				</select>
			</span>
		);
	}
}

CartItemUseOnDay.defaultProps = {};

CartItemUseOnDay.propTypes = {
	className: PropTypes.string,
	isDesignMode: PropTypes.bool,
	cartItemId: PropTypes.string,
	useOnDays: PropTypes.arrayOf(PropTypes.shape({
		description: PropTypes.string,
		value: PropTypes.string
	})),
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string
};

module.exports = CartItemUseOnDay;
